export const SEP_RE = /\s*,\s*|\s+(AND|OR)(?=\s|$)/gi;
export const HAS_SEP = /\s+(AND|OR)(?=\s|$)|,/i;
export const FRAGMENT_SEP_RE = /\s*,\s*|\s+(?:AND|OR)(?=\s|$)/gi;
export const TRAILING_OP_ONLY_RE = /\s+(AND|OR)\s*$/i;
export const QUERY_SLOT = '__QUERY_SLOT__';

export type Op = 'AND' | 'OR';

export interface ParsedQuery {
  keywords: string[];
  ops: Op[];
  trailingOp?: Op;
}

export function parseQuery(input: string): ParsedQuery {
  const parts = input.split(SEP_RE);
  const keywords: string[] = [];
  const ops: Op[] = [];
  for (let i = 0; i < parts.length; i += 2) {
    const keyword = (parts[i] ?? '').trim();
    if (!keyword) continue;
    keywords.push(keyword);
    if (keywords.length > 1) {
      const captured = parts[i - 1];
      ops.push(captured && /^or$/i.test(captured) ? 'OR' : 'AND');
    }
  }
  let trailingOp: Op | undefined;
  if (keywords.length > 0 && parts.length >= 3) {
    const tail = (parts[parts.length - 1] ?? '').trim();
    if (!tail) {
      const lastSep = parts[parts.length - 2];
      trailingOp = lastSep && /^or$/i.test(lastSep) ? 'OR' : 'AND';
    }
  }
  return { keywords, ops, trailingOp };
}

export function lastSepEnd(input: string): number {
  const re = new RegExp(FRAGMENT_SEP_RE.source, 'gi');
  let last = 0;
  let m;
  while ((m = re.exec(input)) !== null) {
    last = m.index + m[0].length;
    if (m[0].length === 0) re.lastIndex += 1;
  }
  while (last < input.length && /\s/.test(input[last])) last += 1;
  return last;
}

export function extractFragment(input: string): string {
  if (TRAILING_OP_ONLY_RE.test(input)) return '';
  return input.slice(lastSepEnd(input)).trim();
}

export const flipOp = (op: Op): Op => (op === 'AND' ? 'OR' : 'AND');
